/** Same-origin path → client-side navigation (no full document reload). */
export function isInternalPath(href: string): boolean {
  const path = href.trim();
  if (!path) return false;
  if (path.startsWith("mailto:") || path.startsWith("tel:")) return false;
  if (path.startsWith("//")) return false;
  if (path.startsWith("/") || path.startsWith("#")) return true;

  try {
    const base =
      typeof window !== "undefined" ? window.location.origin : "https://www.enabase.com";
    return new URL(path, base).origin === base;
  } catch {
    return false;
  }
}
